import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useCallback, useMemo } from 'react';

var _excluded = ["onFocus", "disabled", "loading", "children", "onClick", "onKeyDown"];
var useButton = function useButton(props) {
  var onFocus = props.onFocus,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      children = props.children,
      onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  var handleFocus = useCallback(function (e) {
    if (typeof onFocus === 'function') {
      onFocus(e);
    }
  }, [onFocus]);
  var handleClick = useCallback(function (e) {
    if (typeof onClick === 'function' && !disabled && !loading) {
      onClick(e);
    }
  }, [disabled, loading, onClick]);
  var handleKeyDown = useCallback(function (e) {
    if (e && (e.key === 'Enter' || e.key === 'Space') && (disabled || loading)) {
      e.preventDefault();
    }

    if (!disabled && typeof onKeyDown === 'function') {
      onKeyDown(e);
    }
  }, [disabled, loading, onKeyDown]);
  var isLoading = useMemo(function () {
    return Boolean(loading && !disabled);
  }, [disabled, loading]);
  return _extends({
    isLoading: isLoading,
    handleFocus: handleFocus,
    disabled: disabled,
    loading: loading,
    children: children,
    onClick: onClick,
    handleClick: handleClick,
    handleKeyDown: handleKeyDown,
    onKeyDown: onKeyDown
  }, attrs);
};

export { useButton };
